var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllAct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0294,
    y: 0.606201,
    width: 48,
    height: 48,
    rx: 10,
    transform: "rotate(15 15.0294 0.606201)",
    fill: "#36BFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_43161_502)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 34.0001L14 48.0001M30 41.0001H21M18.6 45.0001H25.3373C25.5818 45.0001 25.7041 45.0001 25.8192 44.9724C25.9213 44.9479 26.0188 44.9075 26.1083 44.8527C26.2092 44.7909 26.2957 44.7044 26.4686 44.5314L31.5 39.5001C31.739 39.2611 31.8584 39.1416 31.9546 39.0358C34.0348 36.7474 34.0348 33.2527 31.9546 30.9643C31.8584 30.8585 31.739 30.739 31.5 30.5001C31.261 30.2611 31.1416 30.1416 31.0358 30.0455C28.7473 27.9653 25.2527 27.9653 22.9642 30.0455C22.8584 30.1416 22.739 30.2611 22.5 30.5001L17.4686 35.5314C17.2957 35.7044 17.2092 35.7909 17.1474 35.8918C17.0925 35.9813 17.0521 36.0788 17.0276 36.1808C17 36.2959 17 36.4182 17 36.6628V43.4001C17 43.9601 17 44.2401 17.109 44.4541C17.2049 44.6422 17.3578 44.7952 17.546 44.8911C17.7599 45.0001 18.0399 45.0001 18.6 45.0001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_43161_502",
    x: -16,
    y: -2,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_43161_502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_43161_502",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAct);
export default __webpack_public_path__ + "static/media/allAct.2fad003c97e9ac1d5a7acf1c560059be.svg";
export { ForwardRef as ReactComponent };